import { type FC, type ReactNode } from "react";
import classNames from "classnames";
import { variantClassname } from "../../utils/misc";

export type ParameterProps = JSX.IntrinsicElements["div"] & {
  label: ReactNode;
  value?: ReactNode;
  variant?: "vertical" | "horizontal" | "search-page";
  cutOverflow?: boolean;
  "data-test-id"?: string;
};

/**
 * A simple pair - label + value when describing a product
 * @param props
 * @constructor
 */
const Parameter: FC<ParameterProps> = (props) => {
  const {
    label,
    value,
    className,
    children,
    "data-test-id": testId,
    variant = "vertical",
    cutOverflow,
    ...divProps
  } = props;

  const cls = classNames(
    variantClassname("scha__param", variant),
    cutOverflow && "scha__param--cut-overflow",
    className
  );

  return (
    <div {...divProps} className={cls}>
      <div className={"scha__param__label"}>{label}</div>
      <div className={"scha__param__value"} data-test-id={testId}>
        {children || value}
      </div>
    </div>
  );
};

export default Parameter;

interface ReverseParamProps {
  label: ReactNode;
  children?: ReactNode;
}
export const ReverseParam = ({ label, children }: ReverseParamProps) => {
  return (
    <div>
      <div className="mb-1">{label}</div>
      {children && <div className="f-label-color">{children}</div>}
    </div>
  );
};
